import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./ContactUs.css";
import { useNavigate } from "react-router-dom";
import { useContactUsQueryMutation } from "../../services/userAuthApi";

const ContactUs = () => {
  const navigate = useNavigate();
  const [apiError, setApiError] = useState("");
  const [apiSuccess, setApiSuccess] = useState("");
  const [contactUsQuery] = useContactUsQueryMutation();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    pincode: "",
    message: "",
  });

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setApiError("");
    setApiSuccess("");

    try {
      const response = await contactUsQuery(formData).unwrap();
      
      if (response.success) {
        setApiSuccess("Thank you for contacting us! We'll get back to you soon.");
        setFormData({
          name: "",
          email: "",
          phone: "",
          city: "",
          pincode: "",
          message: "",
        });
      } else {
        setApiError(response.message || "Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Contact form error:", error);
      setApiError(error?.data?.message || "Failed to send message. Please try again.");
    }
  };

  return (
    <>
      <section className="contact-section py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="text-center mb-5">
                <h2 className="contact-title">Contact Us</h2>
                {/*<p className="contact-subtitle">
                  One India. One Pet Platform. Endless possibilities.
                </p>*/}
              </div>

              {/* API Messages */}
              {apiError && (
                <div className="alert alert-danger alert-dismissible fade show mb-4" role="alert">
                  {apiError}
                  <button type="button" className="btn-close" onClick={() => setApiError("")}></button>
                </div>
              )}
              {apiSuccess && (
                <div className="alert alert-success alert-dismissible fade show mb-4" role="alert">
                  {apiSuccess}
                  <p className="contact-subtitle">Our team will revert to you within 24 hours.</p>
                  <button type="button" className="btn-close" onClick={() => setApiSuccess("")}></button>
                </div>
              )}

              {/* STATIC CONTACT FORM */}
              <form onSubmit={handleContactSubmit}>
              
              <div className="row">
                  <div className="col-md-6">
                <div className="contact-field">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-control"
                    placeholder="Enter your full name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="contact-field">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control"
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="contact-field">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="form-control"
                    placeholder="Enter your phone number"
                    value={formData.phone}
                    onChange={handleInputChange}
                  />
                </div>
                </div>
                <div className="col-md-6">
                <div className="contact-field">
                  <label htmlFor="city">City</label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    className="form-control"
                    placeholder="Enter your city"
                    value={formData.city}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="contact-field">
                  <label htmlFor="pincode">Pincode</label>
                  <input
                    type="text"
                    id="pincode"
                    name="pincode"
                    className="form-control"
                    placeholder="Enter your pincode"
                    value={formData.pincode}
                    onChange={handleInputChange}
                  />
                </div>

                
                </div>
                <div className="col-md-12">
                    <div className="contact-field">
                  <label htmlFor="message">Your Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="2"
                    className="form-control"
                    placeholder="How can we help you?"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                  ></textarea>
                </div>
                </div>
                <div className="text-center mt-4">
                  <button type="submit" className="btn register-btn">
                    Send Message
                  </button>
                </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
